import { combineReducers } from "redux";
import activeListingsReducer from "office/reports/activeListings/reducer";
import leadsReducer from "office/reports/leads/reducer";
import agentsReducer from "office/reports/agents/reducer";
import statsReducer from "office/reports/stats/reducer";
export const officeReportsReducer = combineReducers({
    activeListings: activeListingsReducer,
    leads: leadsReducer,
    agents: agentsReducer,
    officeStats: statsReducer
});
